import React, { useState } from 'react';
import './ReadMore.css';
import Button2 from '../Button2/Button2';


interface readMoreObj {
    text: string;
}

const ReadMore: React.FC<readMoreObj> = ({ text }) => {
    const [isToggled, showText] = useState<boolean>(false);

    // Handler to toggle the state
    const handleToggle = () => {
        showText((prev: boolean) => !prev);
    };

    return (

        <div>
            <Button2 onClick={handleToggle} name="readMore" text="Read more..." />
            {isToggled && (
                <div>
                    <p className="preserve-newlines">
                        {text}
                    </p>
                    <br />
                </div>
            )}{" "}
        </div>

    );
};

export default ReadMore;